import { StateCreator } from 'zustand';

export interface RecordingSlice {
  recording: boolean;
  setIsRecording: (recording: boolean) => void;
}

export const recordingSlice: StateCreator<RecordingSlice> = (set) => ({
  recording: false,
  setIsRecording: (recording) => set({ recording }),
});
